import { BriefcaseIcon, ListBulletIcon, CalendarDaysIcon, TruckIcon, UsersIcon, CalendarIcon, SwatchIcon } from '@heroicons/react/24/outline'
import { NAV_TYPE_COLLAPSE, NAV_TYPE_ITEM } from 'constants/app.constant'

export const jobs = {
    id: 'jobs',
    type: NAV_TYPE_COLLAPSE,
    path: '/jobs',
    title: 'Jobs',
    transKey: 'Jobs Management',
    Icon: BriefcaseIcon,
    permissionCode: "JBJOBView",
    childs: [
        {
            id: 'jobs.list',
            type: NAV_TYPE_ITEM,
            path: '/jobs',
            title: 'Jobs List',
            transKey: 'Jobs List',
            Icon: ListBulletIcon,
            permissionCode: "MGJBJV"
        },
        {
            id: 'jobs.schedules.list',
            type: NAV_TYPE_ITEM,
            path: '/jobs/schedules',
            title: 'Schedules List',
            transKey: 'Schedules List',
            Icon: ListBulletIcon
        },
        // {
        //     id: 'jobs.schedules.job',
        //     type: NAV_TYPE_ITEM,
        //     path: '/jobs/schedules/job-schedule',
        //     title: 'Job Schedule',
        //     transKey: 'Job Schedule',
        //     Icon: CalendarIcon
        // },
        // {
        //     id: 'jobs.schedules.traders',
        //     type: NAV_TYPE_ITEM,
        //     path: '/jobs/schedules/traders-suppliers',
        //     title: 'Traders & Suppliers',
        //     transKey: 'Traders & Suppliers',
        //     Icon: TruckIcon
        // },
        // {
        //     id: 'jobs.schedules.workers',
        //     type: NAV_TYPE_ITEM,
        //     path: '/jobs/schedules/workers-boys',
        //     title: 'Workers/Boys',
        //     transKey: 'Workers/Boys',
        //     Icon: UsersIcon
        // },
        {
            id: 'jobs.my-jobs',
            type: NAV_TYPE_ITEM,
            path: '/jobs/my-calendar',
            title: 'Job Calendar',
            transKey: 'Job Calendar',
            Icon: CalendarDaysIcon
        },
        // {
        //     id: 'jobs.selections',
        //     type: NAV_TYPE_ITEM,
        //     path: '/project-management/selections',
        //     title: 'Selections',
        //     transKey: 'Selections',
        //     Icon: SwatchIcon
        // },
    ]
}
